module.exports = __webpack_public_path__ + "static/images/exclamation.3uaL0EZ.svg";